import { useState } from "react";
import { Search, Tag } from "lucide-react";
import { Button } from "../../ui/button";
import { SearchBarProps } from "../interfaces/EndpointInterfaces";
import TenantLists from "../TenantLists";
import DeviceTags from "./DeviceTags";
import PlatformFilter, { PlatformGroupToggle } from "./PlatformFilter";



export default function SearchBar({
  placeholder = "Search...",
  onSearch,
  onSelectorChange,
  lastSelectedDevice,
  onTagsChange,
  resetValue,
  platformFilter = null,
  onPlatformFilterChange,
  groupByPlatform = false,
  onGroupByPlatformChange,
}: SearchBarProps) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showTagsDialog, setShowTagsDialog] = useState(false);



  const handleSearch = (value: string) => {
    setSearchQuery(value);
    onSearch?.(value);
  };



  return (
    <div className="flex min-w-0 flex-1 basis-full lg:basis-[480px] items-center gap-4 lg:gap-6 flex-wrap">
      <TenantLists onSelectorChange={onSelectorChange} isLabelNeeded={true} variant="card" />

      <div className="hidden sm:block w-px h-12 bg-gradient-to-b from-transparent via-border to-transparent" />
      <div className="flex flex-col gap-1.5 flex-1 min-w-[200px]">
        <label htmlFor="endpoint-search" className="text-[11px] font-medium text-muted-foreground/70 uppercase tracking-wider flex items-center gap-1.5 px-1">
          <Search className="w-3.5 h-3.5" />
          Search
        </label>
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-card border border-border/50 hover:border-sky-500/30 transition-all duration-300 focus-within:ring-1 focus-within:ring-sky-500/50 shadow-sm">
          <Search className="w-4 h-4 text-muted-foreground flex-shrink-0" />
          <input
            id="endpoint-search"
            type="text"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full min-w-0 bg-transparent outline-none border-none text-sm font-medium text-foreground placeholder:text-muted-foreground"
            data-testid="input-search"
          />
        </div>
      </div>

      {onPlatformFilterChange && (
        <div className="self-end">
          <PlatformFilter value={platformFilter} onChange={onPlatformFilterChange} />
        </div>
      )}

      {onGroupByPlatformChange && (
        <div className="self-end">
          <PlatformGroupToggle pressed={groupByPlatform} onChange={onGroupByPlatformChange} />
        </div>
      )}

      {lastSelectedDevice && <Button
        variant="outline"
        className="flex items-center space-x-2 rounded-xl px-4 py-2.5 mt-5"
        onClick={() => setShowTagsDialog(true)}
        data-testid="button-tags"
      >
        <Tag className="w-4 h-4" />
        <span>Tags</span>
      </Button>}



      <DeviceTags
        open={showTagsDialog}
        onOpenChange={setShowTagsDialog}
        device={lastSelectedDevice || null}
        onSave={(deviceId, existingTags, newTags) => {
          onTagsChange?.(deviceId, existingTags, newTags);
          setShowTagsDialog(false)
          resetValue?.()
        }}
        onClose={() => {
          resetValue?.()
        }}
      />

    </div>
  );
}
